import './bootstrap';
import '../css/app.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { RouteContext } from '@/Hooks/useRoute';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { CookiesProvider } from 'react-cookie';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://0997dd34950d73dfc8f6c6ece890602a@o4507860402176000.ingest.de.sentry.io/4509049125470288",
  enabled: import.meta.env.MODE === 'production'
});

const appName =
  window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
  title: title => `${title} - ${appName}`,
  progress: {
    color: '#4B5563',
  },
  resolve: name =>
    resolvePageComponent(
      `./Pages/${name}.tsx`,
      import.meta.glob('./Pages/**/*.tsx'),
    ),
  setup({ el, App, props }) {
    const root = createRoot(el);
    return root.render(
      <RouteContext.Provider value={(window as any).route}>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <App {...props} />
        </CookiesProvider>
      </RouteContext.Provider>,
    );
  },
});
